import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import CSSModules from 'react-css-modules'
import classNames from 'classnames'

import Isvg from 'react-inlinesvg'

import styles from './answer_drag.scss'

import CheckboxSvg from 'assets/components/answer/checkbox.svg'

class QuizAnswerDrag extends PureComponent {

	render() {
		return (
			<div styleName='wrapper'>
				<div styleName={classNames({
					checkbox: true,
					'checkbox--checked': this.props.checked,
				})}>
					<Isvg src={CheckboxSvg} cacheGetRequests={true} styleName='checkbox-icon' />
				</div>
				<p styleName={classNames({
					text: true,
					'text--correct': this.props.checked,
				})}>{this.props.value}</p>
			</div>
		)
	}

}

QuizAnswerDrag.propTypes = {
	checked: PropTypes.oneOfType([
		PropTypes.bool,
		PropTypes.number,
	]),
	value: PropTypes.string,
}

export default CSSModules(QuizAnswerDrag, styles, {allowMultiple: true})
